import styled from '@emotion/styled';

const DefaultButton = styled.button<{
    fullWidth?: boolean;
    thick?: boolean;
    hasBorder?: boolean;
    disabled?: boolean;
}>`
    height: ${({ thick }) => (thick ? '60px' : '50px')};
    position: relative;
    outline: none;
    text-transform: uppercase;
    box-sizing: border-box;
    align-items: center;
    padding: ${({ thick }) => (thick ? '16px 16px' : '10px 16px')};
    cursor: pointer;
    width: ${({ fullWidth }) => (fullWidth ? '100%' : 'auto')};
    opacity: ${({ disabled }) => (disabled ? '0.5' : '1')};
    font-family: ${({ theme }) => theme.base.font.family.button};
    font-weight: ${({ theme }) => theme.base.font.weight.bold};

    &:active {
        transform: scale(0.97);
    }

    transition: 0.1s ease;
`;

export const OutlinedPrimaryStyledButton = styled(DefaultButton)<{ hasBorder?: boolean }>`
    font-size: ${({ theme }) => theme.feature.buttonSecondary.fontSize};
    background: ${({ theme }): string => theme.feature.buttonSecondary.background};
    border: ${({ theme, hasBorder }) =>
        hasBorder ? `2px solid ${theme.feature.buttonSecondary.borderColor}` : '0px'};
    border-radius: ${({ theme }) => theme.feature.buttonSecondary.borderRadius};
    color: ${({ theme }): string => theme.feature.buttonSecondary.fontColor};
    & span {
        color: ${({ theme }): string => theme.feature.buttonSecondary.fontColor};
    }
`;

export const PrimaryStyledButton = styled(DefaultButton)<{ hasBorder?: boolean }>`
    font-size: ${({ theme }) => theme.feature.buttonMain.fontSize};
    border-radius: ${({ theme }) => theme.feature.buttonMain.borderRadius};
    background-color: ${({ theme }): string => theme.feature.buttonMain.background};
    border: ${({ theme, hasBorder }) =>
        hasBorder ? `1px solid ${theme.feature.buttonMain.background}` : '0px'};
    color: ${({ theme }): string => theme.feature.buttonMain.fontColor};

    & span {
        color: ${({ theme }): string => theme.feature.buttonMain.fontColor};
    }
`;

export const ChildrenContainer = styled.div<{ isLoading: boolean }>`
    opacity: ${({ isLoading }) => (isLoading ? 0 : 1)};
    display: flex;
    justify-content: center;
    align-items: center;

    & > *:not(:last-child) {
        margin-right: 12px;
    }
`;

export const LoadingContainer = styled.div`
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
`;

export const ButtonChips = styled.div`
    background: ${({ theme }): string => theme.feature.buttonMain.background};
    height: 30px;
    width: 30px;
    border-radius: ${({ theme }): string => theme.base.radius.md};
    position: absolute;
    left: 10px;
    top: 10px;
    bottom: 10px;
`;
